module.exports = __webpack_public_path__ + "img/thumbnail_HimalayanBrownBear_j_normal.53fb1049.png";